import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const StyledContainerGrid = styled(Grid)`
  margin: ${({ theme }) => theme.spacing(3, -2.5, 1)};
  padding: ${({ theme }) => theme.spacing(0, 2.5)};
  width: auto;

  &:hover {
    background-color: ${({ theme }) => theme.palette.background.boxDark};

    .clearIcon {
      visibility: visible;
    }
  }
`;

const StyledRemoveIconButton = styled(IconButton)`
  padding: ${({ theme }) => theme.spacing(0.5)};
  visibility: hidden;
`;

const StyledTitleTypography = styled(Typography)`
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  margin-right: ${({ theme }) => theme.spacing(0.5)};
  text-transform: uppercase;
`;

interface SectionTitleProps {
  onClear: () => void;
  title: string;
  readonly?: boolean;
}

export function FiltersTitle(props: SectionTitleProps) {
  const { onClear, title, readonly } = props;

  return (
    <StyledContainerGrid container sx={{ alignItems: 'center' }}>
      <StyledTitleTypography variant="body1" data-test={`aq-${title.toLocaleLowerCase().split(' ')[0]}`}>
        {title}
      </StyledTitleTypography>
      {!readonly && (
        <StyledRemoveIconButton className="clearIcon" onClick={onClear} size="large">
          <CloseIcon data-test="close-dialog" fontSize="small" />
        </StyledRemoveIconButton>
      )}
    </StyledContainerGrid>
  );
}
